var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 일정별 컴포넌트
 *
 ********************************************************************/
import { useEffect, useRef, useState } from "react";
// recoli
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { SpgTreeState, alertState, checkTypeState, curSchduleTreeState, todayState, } from "../../../../recoil/assessmentState";
import { dailyInfo, dailyState, infoPop, itemInfoState, reLoad, reLoadPage, reloadScroll, reloadToady, userInfoLoginState, } from "../../../../recoil/userState";
// utils
import { useNavigate } from "react-router-dom";
import { loadingBoxState } from "../../../../recoil/menuState";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import * as CONST from "../../../../utils/Const";
import EhpPagination from "../../../common/pagination/EhpPagination";
import CalendarView from "./CalendarView";
// datepicker
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import { enUS, ko } from "date-fns/esm/locale";
import { langId, langState } from "../../../../recoil/langState";
import { useTrans } from "../../../../utils/langs/useTrans";
function DaysMain(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoileitemList, setRecoileitemList] = useRecoilState(dailyState);
    const setRecoilitemList = useSetRecoilState(itemInfoState);
    const reload = useRecoilValue(reLoad);
    const setReloadToady = useSetRecoilState(reloadToady);
    const [recoilSpgData, setRecoilSpgData] = useRecoilState(SpgTreeState);
    const recoilMemo = useRecoilValue(dailyInfo);
    const [recoilToday, setrecoilToday] = useRecoilState(todayState);
    const langs = useRecoilValue(langState);
    const langIds = useRecoilValue(langId);
    // props
    const { curTree, handleOpenPop } = props;
    // Mobile Check용
    const mobileRef = useRef(null);
    const [isMobile, setMobile] = useState(false);
    // width 1650 Check용
    const [is1650M, setIs1650M] = useState(false);
    useEffect(() => {
        // resize handler
        function handleResize() {
            // 모바일 체크
            if (window.innerWidth <= 1650) {
                setIs1650M(true);
            }
            else {
                setIs1650M(false);
            }
            if (window.innerWidth <= 940) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
        if (window.innerWidth <= 1650) {
            setIs1650M(true);
        }
    }), 100);
    // useState
    const [dayItem, setDayItem] = useState(null);
    const [today, setToday] = useState(recoilToday ? recoilToday : dayjs(new Date()));
    const [month, setMonth] = useState(dayjs(today).format("YYYYMM"));
    const [tabType, setTabType] = useState("memo");
    const [dailySwitch, setDailySwitch] = useState(1);
    const [dayMemo, setDayMemo] = useState(false);
    const [popReset, setPopreset] = useState(false);
    const [nodata, setNodata] = useState(false);
    const [checkItem, setCheckItem] = useState([]);
    const [checkArr, setCheckArr] = useState([]);
    // 검색
    const searchFieldList = [
        { id: 1, sfDisp: t("라벨.형명"), sfVal: "itemName" },
        { id: 2, sfDisp: t("라벨.시리얼번호"), sfVal: "serialNo" },
        { id: 3, sfDisp: t("라벨.판넬명"), sfVal: "panelName" },
    ];
    const [searchText, setSearchText] = useState("");
    const [searchTextField, setSearchTextField] = useState({
        searchField: "",
        searchText: "",
    });
    let appPath = `zoneId=${curTree.zone.zoneId}&yyyymm=${month}`;
    if (curTree.subZone.subZoneId) {
        appPath = appPath + `&subZoneId=${curTree.subZone.subZoneId}`;
    }
    // 전기실
    if (curTree.room.roomId) {
        appPath = appPath + `&roomId=${curTree.room.roomId}`;
    }
    // spg
    if (curTree.spg.companySpgId > 0) {
        appPath = appPath + `&companySpgId=${curTree.spg.companySpgId}`;
    }
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/schedule/monthlyList?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setDayItem(data.body);
                setRecoilitemList({
                    id: -1,
                    itemId: "",
                    type: "daily",
                    itemName: "",
                    panelName: "",
                    serialNo: "",
                    spgId: -1,
                });
                setRecoilSpgData({
                    spg: { companySpgId: -1, spgId: -1, spgName: "" },
                });
                if (recoilToday) {
                    setrecoilToday(recoilToday);
                }
                else {
                    setrecoilToday(null);
                }
            }
            else {
                // alert(data.body.map((err) => (err.msg)))
            }
        }
    }, [data, today, month, langIds]);
    // 캘린더 Arr || 비트연산 LS=8, 직무=4,기타=2,일정별메모=1 ||
    let highlightedDays = dayItem &&
        dayItem.dates.map((days) => (Object.assign(Object.assign({}, days), { date: days.date, ech: days.bitDisplay & 8, job: days.bitDisplay & 4, etc: days.bitDisplay & 2, memo: days.bitDisplay & 1 })));
    //  메모,월별일정,미이행항목 tab 이동
    function DayTab(e, type) {
        e.preventDefault();
        setTabType(type);
    }
    function DailySwitch(e, num) {
        e.preventDefault();
        setDailySwitch(num);
        setRecoileitemList(Object.assign(Object.assign({}, recoileitemList), { status: num }));
        setReloadToady(true);
    }
    const [openPop, setOpenPop] = useState("pop-memo");
    // 메모 등록, 메모 수정,메모 삭제 팝업, 설비등록 팝업
    useEffect(() => {
        // 설비 등록
        handleOpenPop("pop-s-add", _jsx(ItemPop, { curTree: curTree, handleOpenPop: handleOpenPop, setCheckItem: setCheckItem, checkArr: checkArr, setCheckArr: setCheckArr, popReset: popReset, setPopreset: setPopreset, isMobile: isMobile, htmlClose: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ItemPopClose("pop-s-add") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }));
        // 메모 등록, 수정
        if (openPop == "pop-memo") {
            handleOpenPop("pop-memo", _jsx(MemePop, { curTree: curTree, dayMemo: dayMemo, setDayMemo: setDayMemo, today: today, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: dayjs(today).format("YYYY-MM-DD") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => MemoPopClose("pop-memo") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        }
        // 메모 삭제
        if (openPop == "pop-delete-memo") {
            handleOpenPop("pop-delete-memo", _jsx(DeletePop, { recoilMemo: recoilMemo }));
            setOpenPop("pop-memo");
        }
        // 검색 팝업
        handleOpenPop("pop-search-small", _jsx(SearchPop, { searchFieldList: searchFieldList, searchText: searchText, setSearchText: setSearchText, setSearchTextField: setSearchTextField }));
    }, [curTree, openPop, searchText, checkItem, popReset, today]);
    const onClickPop = (e, popId) => {
        setOpenPop(popId);
        CUTIL.jsopen_Popup(e);
    };
    function MemoPopClose(id) {
        CUTIL.jsclose_Popup(id);
        setDayMemo(true);
    }
    function ItemPopClose(id) {
        CUTIL.jsclose_Popup(id);
        setPopreset(true);
        setCheckItem([]);
        setCheckArr([]);
        setRecoilSpgData({
            spg: { companySpgId: -1, spgId: -1, spgName: "" },
        });
    }
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: `box__body ` }, { children: _jsxs("section", Object.assign({ className: "flex-row m-m24" }, { children: [_jsxs("div", Object.assign({ className: "body-left" }, { children: [_jsxs("div", Object.assign({ className: "left-top" }, { children: [_jsx("div", Object.assign({ className: "calendar-area" }, { children: curTree.zone.zoneId && (_jsx(CalendarView, { highlightedDays: highlightedDays, today: today, setToday: setToday, setMonth: setMonth })) })), _jsxs("div", Object.assign({ className: "color-info" }, { children: [_jsx("p", Object.assign({ className: "ehc" }, { children: t("스케쥴.캘린더.LS") })), _jsx("p", Object.assign({ className: "etc" }, { children: t("스케쥴.캘린더.고객향점검") })), _jsx("p", Object.assign({ className: "memo" }, { children: t("라벨.메모") }))] }))] })), _jsxs("div", Object.assign({ className: "left-bottom m-h200" }, { children: [_jsxs("ul", Object.assign({ className: "tab__box m-none" }, { children: [_jsx("li", Object.assign({ className: `${tabType == "memo" ? "on" : ""}`, onClick: (e) => DayTab(e, "memo") }, { children: _jsx("a", Object.assign({ href: "#" }, { children: t("라벨.메모") })) })), _jsx("li", Object.assign({ className: `${tabType == "month" ? "on" : ""}`, onClick: (e) => DayTab(e, "month") }, { children: _jsx("a", Object.assign({ href: "#" }, { children: t("스케쥴.월별일정") })) })), _jsx("li", Object.assign({ className: `${tabType == "nonchecker" ? "on" : ""}`, onClick: (e) => DayTab(e, "nonchecker") }, { children: _jsx("a", Object.assign({ href: "#" }, { children: t("스케쥴.미이행항목") })) }))] })), curTree.zone.zoneId && today && (_jsxs("div", Object.assign({ className: "tabbox-cont" }, { children: [_jsxs("div", Object.assign({ className: `cont-memo ${recoilMemo && recoilMemo.content.length > 0 ? "" : "nodata"}`, style: { display: tabType !== "memo" ? "none" : "" } }, { children: [_jsxs("div", Object.assign({ className: "memo-top" }, { children: [_jsx("p", Object.assign({ className: "m-block title" }, { children: t("라벨.점검메모") })), _jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g js-open", "data-pop": "pop-memo", onClick: (e) => onClickPop(e, "pop-memo") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })), recoilMemo.memoId > 0 && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete-memo", onClick: (e) => onClickPop(e, "pop-delete-memo") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })))] })), _jsx("div", Object.assign({ className: "memo-box" }, { children: _jsx("textarea", { readOnly: true, value: recoilMemo.content }) })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("스케쥴.NODATA.미이행항목") }))] })), _jsxs("div", Object.assign({ className: `cont-tbl m-none ${dayItem && dayItem.monthlyPlan.length > 0 ? "" : "nodata"}`, style: { display: tabType !== "month" ? "none" : "" } }, { children: [_jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("스케쥴.NODATA.월별일정") })), _jsx("div", Object.assign({ className: "tbl-list row" }, { children: _jsxs("table", Object.assign({ summary: "\uC6D4\uBCC4 \uC77C\uC815 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC6D4\uBCC4 \uC77C\uC815 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "30%" } }), _jsx("col", { style: { width: "80px" } }), _jsx("col", { style: { width: "30%" } })] }), _jsx("tbody", { children: dayItem &&
                                                                        dayItem.monthlyPlan.map((month, idx) => (_jsxs("tr", Object.assign({ onClick: (e) => setToday(dayjs(month.date)) }, { children: [_jsx("td", { children: month.date }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: month.spgName == "ALL" ? month.productName : month.spgName })) }), _jsxs("td", { children: [month.scheduleCount, _jsx("img", { src: require("/static/img/icon_more.png"), alt: "\uB354\uBCF4\uAE30" })] })] }), "month_todo" + idx.toString()))) })] })) }))] })), _jsxs("div", Object.assign({ className: `cont-tbl m-none ${dayItem && dayItem.expiredPlan.length > 0 ? "" : "nodata"}`, style: { display: tabType !== "nonchecker" ? "none" : "" } }, { children: [_jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("스케쥴.NODATA.미이행항목") })), _jsx("div", Object.assign({ className: "tbl-list row" }, { children: _jsxs("table", Object.assign({ summary: "\uBBF8\uC774\uD589\uD56D\uBAA9 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uBBF8\uC774\uD589 \uD56D\uBAA9" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "30%" } }), _jsx("col", { style: { width: "80px" } }), _jsx("col", { style: { width: "30%" } })] }), _jsx("tbody", { children: dayItem &&
                                                                        dayItem.expiredPlan.map((non, idx) => (_jsxs("tr", Object.assign({ onClick: (e) => setToday(dayjs(non.date)) }, { children: [_jsx("td", { children: non.date }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: non.spgName == "ALL" ? non.productName : non.spgName })) }), _jsxs("td", { children: [non.scheduleCount, _jsx("img", { src: require("/static/img/icon_more.png"), alt: "\uB354\uBCF4\uAE30" })] })] }), "nonchecker" + idx.toString()))) })] })) }))] }))] })))] }))] })), _jsxs("div", Object.assign({ className: "body-right" }, { children: [_jsxs("div", Object.assign({ className: "right-top" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: dayjs(today).format("YYYY-MM-DD") })), _jsxs("ul", Object.assign({ className: "tab__toggle" }, { children: [_jsx("li", Object.assign({ className: `${dailySwitch == 1 ? "on" : ""}`, onClick: (e) => DailySwitch(e, 1) }, { children: _jsx("a", Object.assign({ href: "#" }, { children: t("라벨.금일예정") })) })), _jsx("li", Object.assign({ className: `${dailySwitch == 2 ? "on" : ""}`, onClick: (e) => DailySwitch(e, 2) }, { children: _jsx("a", Object.assign({ href: "#" }, { children: t("라벨.금일완료") })) }))] }))] })), curTree.zone.zoneId && (_jsx(DaysTable, { today: today, curTree: curTree, dailySwitch: dailySwitch, recoileitemList: recoileitemList, setRecoileitemList: setRecoileitemList, reload: reload, setNodata: setNodata, isMobile: isMobile, setMobile: setMobile, searchFieldList: searchFieldList, searchText: searchText, setSearchText: setSearchText, searchTextField: searchTextField, setSearchTextField: setSearchTextField }))] }))] })) })) }));
}
export default DaysMain;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
// 금일 예정, 금일 완료 테이블
function DaysTable(props) {
    const navigate = useNavigate();
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoileitemList, setRecoileitemList] = useRecoilState(dailyState);
    const setPopInfo = useSetRecoilState(infoPop);
    const [check, setCheck] = useRecoilState(checkTypeState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [reloadPages, setReloadPages] = useRecoilState(reLoadPage);
    const [reRoadToady, setReloadToady] = useRecoilState(reloadToady);
    const langs = useRecoilValue(langState); // 다국어
    const setReloadScroll = useSetRecoilState(reloadScroll);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    // props
    const { today, curTree, dailySwitch, setNodata, setMobile, mobileRef, searchFieldList, searchText, setSearchText, searchTextField, setSearchTextField, isMobile, } = props;
    // useState
    const [chnanTree, setChnanTree] = useState(null);
    const [dailyItem, setDailyItem] = useState([]);
    const [checkItem, setCheckItem] = useState([]);
    const [typeCheck, setTypeCheck] = useState([]);
    const [searchInit, setSerarchInit] = useState(searchFieldList[0]);
    const [isTempSaveInfo, setIsTempSaveInfo] = useState(null);
    // width 1650 Check용
    const [is1650M, setIs1650M] = useState(false);
    // 페이지
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    const [daychecked, setDayChecked] = useState(today);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 1650) {
                setIs1650M(true);
            }
            else {
                setIs1650M(false);
            }
            if (window.innerWidth <= 940) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
        if (window.outerWidth <= 1650) {
            setIs1650M(true);
        }
    }), 100);
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "updatedTime",
        sort: "desc",
    });
    let appPath = `zoneId=${curTree.zone.zoneId}&yyyymmdd=${dayjs(today).format("YYYYMMDD")}&status=${dailySwitch}`;
    if (curTree.subZone.subZoneId) {
        appPath = appPath + `&subZoneId=${curTree.subZone.subZoneId}`;
    }
    // 전기실
    if (curTree.room.roomId) {
        appPath = appPath + `&roomId=${curTree.room.roomId}`;
    }
    // spg
    if (curTree.spg.companySpgId > 0) {
        appPath = appPath + `&companySpgId=${curTree.spg.companySpgId}`;
    }
    // 검색 필드
    if (searchTextField.searchText.length > 0) {
        appPath = appPath + `&searchKind=${searchTextField.searchField}&stringLike=` + searchTextField.searchText;
    }
    let listPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.size}`;
    // 정렬
    listPath = listPath + `&sort=${sortData.sortField},${sortData.sort}`;
    // type 검색
    let chekFilter = "";
    typeCheck.map((filter, idx) => {
        if (idx > 0)
            chekFilter = chekFilter + ",";
        chekFilter = chekFilter + filter.checkTypeName;
    });
    if (!CUTIL.isnull(chekFilter) && chekFilter.length > 0) {
        listPath = listPath + "&checkType=" + chekFilter;
    }
    // Checktype API
    const { data: checkType } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/schedule/checktypes?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    // 금일 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/schedule/dailyList?${listPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: listPath + reload + reRoadToady + reloadPages + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setReloadPages(false);
                setChnanTree(curTree);
                setDailyItem(data.body);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: isMobile ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, listReload: false })); //5, 10; //5, 10
                setNodata(data.data.page.totalElements <= 0 ? true : false);
                setDayChecked(today);
                // 데이터 없을 땐 작동 안함
                if (data.body.length > 0 && !is1650M) {
                    setRecoileitemList(Object.assign(Object.assign({}, recoileitemList), { id: data.body[0].item.itemIdPk, itemId: data.body[0].item.itemId, scheduleId: data.body[0].scheduleId, type: "daily", status: dailySwitch }));
                }
                else {
                    setRecoileitemList(Object.assign(Object.assign({}, recoileitemList), { id: -1, itemId: "updatedTime", scheduleId: -1, type: "daily", status: dailySwitch }));
                }
                if (dailySwitch == 2) {
                    setCheck(Object.assign(Object.assign({}, check), { assessmentId: data.body.length > 0 ? data.body[0].assessmentId : -1, assessmentInfo: {
                            isTempSave: data.body.length > 0 ? data.body[0].isTempSave : true,
                            reportId: -1,
                        } }));
                }
                else {
                    setCheck(Object.assign(Object.assign({}, check), { assessmentId: -1 }));
                }
                //  초기화
                if ((chnanTree && chnanTree !== curTree) || reRoadToady || reload) {
                    setSortData({
                        sortField: "updatedTime",
                        sort: "desc",
                    });
                    handleCurPage(0);
                    setReloadToady(false);
                    setReload(false);
                    if (!isMobile) {
                        const selectId = document.getElementById("selects");
                        const selectId0 = document.getElementById("selects0");
                        selectId.click();
                        selectId0.click();
                        setSearchText("");
                        setSearchTextField({
                            searchField: searchFieldList[0].sfVal,
                            searchText: "",
                        });
                    }
                }
                setRecoilIsLoadingBox(false);
            }
            else {
                // need error handle
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            if (checkType) {
                if (checkType.codeNum == CONST.API_200) {
                    setRecoilIsLoadingBox(true);
                    setCheckItem(checkType.body);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: checkType.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        }
    }, [data, checkType, is1650M, langIds]);
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            goSearch(e);
        }
    }
    // 웹 검색 버튼 이벤트
    function goSearch(e) {
        var schDiv = document.getElementById("mcheck_searchinput");
        var isSchMobile = schDiv.clientHeight <= 0 && schDiv.clientWidth <= 0 ? true : false;
        if (!isSchMobile) {
            handleCurPage(0);
            const searchVal = {
                text: searchText,
                setSearch: setSearchTextField,
            };
            CUTIL.onClickSearch(searchVal);
        }
        else {
            CUTIL.jsopen_m_Popup(e);
        }
        setReloadPages(true);
    }
    // 정렬 버튼 액션
    function onClickSort(sort) {
        // list 수정
        handleCurPage(0);
        const sortVal = {
            field: sort,
            data: sortData,
            setData: setSortData,
        };
        CUTIL.onClickSort(sortVal);
    }
    function ItemCheck(e, item) {
        if (is1650M && (e.target.nodeName == "P" || e.target.nodeName == "TD")) {
            // e.preventDefault();
            if (item.isTempSave == false) {
                setPopInfo("m-1650");
                CUTIL.jsopen_m_1650_Popup(e);
            }
            else {
                MobileCheck(item);
            }
            if (dailySwitch == 1) {
                setPopInfo("m-1650");
                CUTIL.jsopen_m_1650_Popup(e);
            }
        }
        else {
            setPopInfo("");
        }
        if (dailySwitch == 2) {
            setCheck(Object.assign(Object.assign({}, check), { assessmentId: item.assessmentId, assessmentInfo: {
                    isTempSave: item.isTempSave,
                    reportId: item.reportId,
                } }));
            setReloadScroll(true);
            return;
        }
        else {
            setRecoileitemList(Object.assign(Object.assign({}, recoileitemList), { id: item.item.itemIdPk, itemId: item.item.itemId, scheduleId: item.scheduleId, type: "daily", status: dailySwitch }));
        }
    }
    function ItemCheckM(e, item) {
        // e.preventDefault();
        setPopInfo("m-1650");
        CUTIL.jsopen_m_1650_Popup(e);
        setCheck(Object.assign(Object.assign({}, check), { assessmentId: item.assessmentId, assessmentInfo: {
                isTempSave: item.isTempSave,
                reportId: item.reportId,
            } }));
        setReloadScroll(true);
        return;
    }
    function typeBox(e) {
        let check = e.currentTarget;
        let checkPop = check.querySelector(".popup-cate");
        if (CUTIL.isnull(checkPop))
            return;
        if (checkPop.classList.contains("open")) {
            checkPop.classList.remove("open"); // close
        }
        else {
            checkPop.classList.add("open");
        }
    }
    // checkbox
    function CheckedList(checked, item) {
        // spg 했을 시 중복 가능
        if (checked) {
            setTypeCheck([...typeCheck, item]);
        }
        else {
            setTypeCheck(typeCheck.filter((el) => el !== item));
        }
    }
    // 진단 점검
    function CheckOn(item) {
        setCheck(Object.assign(Object.assign({}, check), { checkType: "daily", checkOn: true, nextStep: "step3", schdeulerId: item.scheduleId, dueDate: item.dueDate, itemInfo: {
                id: item.item.itemIdPk,
                itemId: item.itemitemId,
                itemName: item.item.itemName,
                panelName: item.panelName,
                serialNo: item.item.serialNo,
                spgId: item.companySpgId,
            }, chekVersionTypeInfo: {
                checkVersionId: item.checkVersionId,
                versionNo: "",
            }, inspector: item.inspector, disabled: true }));
    }
    // 이어하기
    function CheckIsTempSave(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/assessment?assessmentId=${item.assessmentId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setCheck(Object.assign(Object.assign({}, check), { checkType: "daily", checkOn: true, nextStep: "checkList", assessmentId: data.body.assessmentId, schdeulerId: item.scheduleId, dueDate: item.dueDate, itemInfo: {
                            id: item.item.itemIdPk,
                            itemId: item.itemitemId,
                            itemName: item.item.itemName,
                            panelName: item.panelName,
                            serialNo: item.item.serialNo,
                            spgId: item.companySpgId,
                        }, chekTypeInfo: {
                            checkTypeId: -1,
                            checkTypeName: data.body.checkTypeName,
                        }, chekSubTypeInfo: {
                            checkSubTypeId: -1,
                            checkSubName: data.body.checkSubTypeName,
                        }, chekVersionTypeInfo: {
                            checkVersionId: data.body.checkVersionId,
                            versionNo: data.body.versionNo,
                        } }));
                }
            }
        });
    }
    function SelectClick(item) {
        if (searchInit !== item) {
            setSearchText("");
            setSerarchInit(item);
        }
    }
    function MobileCheck(daily) {
        if (isMobile) {
            setIsTempSaveInfo(daily);
        }
    }
    // 유형 다른 곳 클릭 시 사라짐
    useEffect(() => {
        const handleClick = (e) => {
            //e.preventDefault();
            const targetElement = e.target;
            const isSelect = targetElement.classList.contains("select-cate") || targetElement.closest(".select-cate");
            if (isSelect) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".popup-cate");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("open");
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: `right-bottom ${pageInfo.totalElements == 0 ? "nodata" : ""}` }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("div", Object.assign({ className: "right" }, { children: _jsxs("div", Object.assign({ className: "searcharea" }, { children: [_jsxs("div", Object.assign({ className: "searchinput", id: "mcheck_searchinput" }, { children: [_jsxs("div", Object.assign({ id: "selects", className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: searchFieldList[0].sfDisp })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList.map((sf, idx) => (_jsx("li", Object.assign({ id: "selects" + idx, className: "option", onClick: (e) => SelectClick(sf), "data-value": sf.sfVal }, { children: sf.sfDisp }), "search_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "input__direct" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-gray js-open-m", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-add ml-10 js-open tooltip-link white", "data-pop": "pop-s-add", "data-tooltip": t("라벨.점검일정추가"), onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uCD94\uAC00" })) }))] })) })) })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("라벨.조회된점검일정이없습니다") })), _jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uC720\uD615,\uD615\uBA85,\uD310\uB12C\uBA85,\uC2DC\uB9AC\uC5BC\uBC88\uD638,\uC810\uAC80\uC9C4\uD589 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC77C\uC815\uBCC4 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC77C\uC815\uBCC4 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", Object.assign({ className: "m-none" }, { children: [_jsx("col", { style: { width: "70px" } }), _jsx("col", { style: { width: "22%" } }), _jsx("col", { style: {} }), _jsx("col", { style: { width: "26%" } }), _jsx("col", { style: { width: "170px" } })] })), _jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", Object.assign({ scope: "col", className: "select-cate w5", onClick: (e) => checkItem.length > 0 && typeBox(e) }, { children: [_jsx("span", Object.assign({ className: "m-none" }, { children: t("라벨.유형") })), _jsx("ul", Object.assign({ className: `popup-cate ` }, { children: checkItem.length > 0 &&
                                                        checkItem.map((item, idx) => (_jsxs("li", { children: [_jsx("input", { type: "checkbox", id: "cate" + idx, checked: typeCheck.includes(item) ? true : false, onChange: (e) => CheckedList(e.target.checked, item) }), _jsx("label", Object.assign({ htmlFor: "cate" + idx }, { children: _jsx("span", { children: item.description }) }))] }, "checktype_" + idx.toString()))) }))] })), _jsx("th", Object.assign({ scope: "col", ref: mobileRef, className: `sort ${sortData.sortField === "itemName" && sortData.sort === "desc" ? "desc" : "asc"} m-none `, onClick: (e) => onClickSort("itemName") }, { children: _jsx("span", { children: t("라벨.형명") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "panelName" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("panelName") }, { children: _jsx("span", { children: t("라벨.판넬명") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "serialNo" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("serialNo") }, { children: _jsx("span", { children: t("라벨.시리얼번호") }) })), _jsx("th", Object.assign({ scope: "col", className: `${dailySwitch == 1 ? "m-none" : ""}` }, { children: _jsx("span", Object.assign({ className: "txt-center" }, { children: t("라벨.상태") })) }))] }) }), _jsx("tbody", { children: dailyItem.length > 0 &&
                                    dailyItem.map((daily, idx) => (_jsxs("tr", Object.assign({ className: `js-open-m-1650 ${dailySwitch == 1 &&
                                            daily.item.itemId + daily.scheduleId === recoileitemList.itemId + recoileitemList.scheduleId
                                            ? "selected"
                                            : dailySwitch == 2 && check.assessmentId == daily.assessmentId
                                                ? "selected"
                                                : ""}`, "data-pop": "m-1650", onClick: (e) => ItemCheck(e, daily) }, { children: [_jsx("td", { children: _jsx("span", Object.assign({ className: `${daily.checkTypeName.split(" ", 1) == "LS" ? "ehc" : daily.checkTypeName.split(" ", 1) == "직무고시" ? "jig" : "etc"}` }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "e-HC" })) })) }), _jsx("td", Object.assign({ className: `m-none ${daily.item.itemName.length > 23 ? " tooltip-link" : ""}`, "data-tooltip": daily.item.itemName }, { children: _jsx("p", Object.assign({ className: "ellipsis " }, { children: daily.item.itemName ? daily.item.itemName : "-" })) })), _jsx("td", Object.assign({ className: `${daily.panelName.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": daily.panelName }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: daily.panelName ? daily.panelName : "-" })) })), _jsx("td", Object.assign({ className: `${daily.item.serialNo.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": daily.item.serialNo }, { children: _jsx("p", Object.assign({ className: "ellipsis " }, { children: daily.item.serialNo ? daily.item.serialNo : "-" })) })), _jsx("td", Object.assign({ className: `${dailySwitch == 1 ? "m-none" : ""}` }, { children: _jsx("div", Object.assign({ className: "flex-inline right gap-12" }, { children: dailySwitch == 1 ? (_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-no", onClick: (e) => CheckOn(daily) }, { children: _jsx("span", { children: t("라벨.점검하기") }) }))) : dailySwitch == 2 && !daily.isTempSave ? (_jsxs(_Fragment, { children: [_jsx("span", { className: `font-14 fontMedium ${isTempSaveInfo && isTempSaveInfo.assessmentId == daily.assessmentId ? "hide" : ""}` }), _jsx("button", Object.assign({ type: "button", className: `btn-basic bg-no wmax-90`, "data-pop": "m-1650", onClick: (e) => ItemCheckM(e, daily) }, { children: _jsx("span", { children: t("라벨.점검완료") }) }))] })) : (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: `${isMobile ? "txt-blue" : "txt-gray"} font-14 fontMedium ${isMobile ? "hide" : ""}`, style: { cursor: isMobile ? "pointer" : "" }, onClick: (e) => MobileCheck(daily) }, { children: t("라벨.임시저장") })), _jsxs("button", Object.assign({ type: "button", className: `btn-basic bg-no `, onClick: (e) => CheckIsTempSave(daily) }, { children: [" ", _jsx("span", { children: t("라벨.이어하기") })] }))] })) })) }))] }), "daily_" + idx.toString()))) })] })) })), pageInfo.totalElements > 0 && (_jsx(EhpPagination, { componentName: "TODAY", pageInfo: pageInfo, handleCurPage: handleCurPage }))] })) }));
}
function MemePop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilMemo, setRecoilMemo] = useRecoilState(dailyInfo);
    const [reload, setReload] = useRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const langIds = useRecoilValue(langId);
    // props
    const { curTree, setDayMemo, dayMemo, today } = props;
    const [dailyMemo, setDailyMemo] = useState("");
    let appPath = `zoneId=${curTree.zone.zoneId}&searchDate=${dayjs(today).format("YYYYMMDD")}`;
    // 메모 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/company/memo?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setRecoilMemo({
                    content: data.body.content,
                    memoId: data.body.memoId,
                });
                setDailyMemo(data.body.content);
            }
            else {
                if (data.errorList.filter((err) => err.field == "memoDate")) {
                    setRecoilMemo({
                        content: "",
                        memoId: -1,
                    });
                    setDailyMemo("");
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
            if (dayMemo) {
                setDailyMemo(recoilMemo.content);
                setDayMemo(false);
            }
        }
    }, [data, dayMemo, langIds]);
    function MemoClose(id) {
        CUTIL.jsclose_Popup(id);
        setDailyMemo(recoilMemo.content);
    }
    function MemoAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: "/product/company/memo",
                appQuery: {
                    memoDate: dayjs(today).format("YYYYMMDD"),
                    content: dailyMemo,
                    zoneId: curTree.zone.zoneId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.등록완료") }));
                    MemoClose("pop-memo");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-memo", type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-memo");
                }
                setReload(false);
                setRecoilIsLoadingBox(false);
            }
        });
    }
    function MemoUpdate(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/product/company/memo/${recoilMemo.memoId}`,
                appQuery: {
                    content: dailyMemo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.내용이수정되었습니다") }));
                    MemoClose("pop-memo");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-memo", type: CONST.TYPE_INNRE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-memo");
                }
                setRecoilIsLoadingBox(false);
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.점검메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: "h170", value: dailyMemo, onChange: (e) => setDailyMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setDailyMemo) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [dailyMemo ? dailyMemo.length : 0, " / 400"] }))] }))] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsxs("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => MemoClose("pop-memo") }, { children: [" ", _jsx("span", { children: t("라벨.취소") })] })), recoilMemo.memoId <= 0 ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => MemoAdd(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))) : (_jsx("button", Object.assign({ type: "button", onClick: (e) => MemoUpdate(e) }, { children: _jsx("span", { children: t("라벨.수정") }) })))] }))] }));
}
function DeletePop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { recoilMemo } = props;
    function MemoDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/product/company/memo/${recoilMemo.memoId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.body }));
                    CUTIL.jsclose_Popup("pop-delete-memo");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    // need error handle
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete-memo", type: CONST.TYPE_INNRE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-delete-memo");
                    setReload(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.작성된메모를삭제하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete-memo") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => {
                            MemoDelete(e);
                        } }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function SearchPop(props) {
    const t = useTrans();
    // props
    const { searchText, setSearchText, setSearchTextField } = props; /* searchFieldList */
    const [searchBoolean, setSearchBoolean] = useState(false);
    const searchFieldList = [
        { id: 1, sfDisp: "판넬명", sfVal: "panelName" },
        { id: 2, sfDisp: "시리얼번호", sfVal: "serialNo" },
    ];
    // 모바일 취소 이벤트 및 초기화
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-search-small");
        setSearchText("");
        setSearchTextField({
            searchField: searchFieldList[0].sfVal,
            searchText: "",
        });
        setSearchBoolean(true);
    }
    // 진입 시 초기화 이벤트
    useEffect(() => {
        setSearchBoolean(false);
    }, [searchBoolean]);
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            handleGoSearch(e);
        }
    }
    function handleGoSearch(e) {
        const searchVal = {
            id: "pop-search-small",
            text: searchText,
            setSearch: setSearchTextField,
        };
        CUTIL.onClickSearch(searchVal);
        CUTIL.jsclose_Popup("pop-search-small");
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("div", Object.assign({ className: "form__input mb-0" }, { children: [_jsxs("div", Object.assign({ className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: !searchBoolean ? searchFieldList[0].sfDisp : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList
                                        .filter((sf) => sf.sfVal !== "itemName")
                                        .map((sf, idx) => (_jsx("li", Object.assign({ className: "option", "data-value": sf.sfVal }, { children: sf.sfDisp }), `sf_${idx.toString()}`))) })] })), _jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => handleGoSearch(e) }, { children: _jsx("span", { children: t("라벨.적용") }) }))] }))] }));
}
function ItemPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curSchduleTreeState);
    const [recoilSpgData, setRecoilSpgData] = useRecoilState(SpgTreeState);
    const langs = useRecoilValue(langState);
    const langIds = useRecoilValue(langId);
    // props
    const { curTree, setCheckItem, checkArr, setCheckArr, handleOpenPop, popReset, setPopreset, isMobile } = props;
    // useState
    const [errorList, setErrorList] = useState([]);
    const [chnanTree, setChnanTree] = useState(null);
    const [itemList, setItemList] = useState([]);
    const [checkingItem, setCheckingItem] = useState([]);
    const [newAdd, setNewAdd] = useState(false);
    const [checkTypeItem, setChecktypeItem] = useState([]);
    const [checkSub, setCheckSub] = useState("");
    const [checkSubTypeItem, setCheckSubtypeItem] = useState([]);
    const [checkVersion, setCheckVersion] = useState("");
    const [checkVersionTypeItem, setCheckVersiontypeItem] = useState([]);
    const [today, setToday] = useState(null);
    const automaticCheckCycle = [
        { cycleNo: t("라벨.없음"), value: 0 },
        { cycleNo: t("라벨.T_일", ["30"]), value: 30 },
        { cycleNo: t("라벨.T_일", ["60"]), value: 60 },
        { cycleNo: t("라벨.T_일", ["90"]), value: 90 },
        { cycleNo: t("라벨.T_일", ["180"]), value: 180 },
        { cycleNo: t("라벨.T_일", ["365"]), value: 365 },
    ];
    const [schduleAdd, setSchduleAdd] = useState({
        checkVersionId: -1,
        isOutSource: false,
        period: null,
        inspector: "",
        itemId: -1,
    });
    const [memo, setMemo] = useState("");
    // 페이지
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    // 검색
    const searchFieldList = [
        { id: 1, sfDisp: t("라벨.형명"), sfVal: "itemName" },
        { id: 2, sfDisp: t("라벨.시리얼번호"), sfVal: "serialNo" },
        { id: 3, sfDisp: t("라벨.판넬명"), sfVal: "panelName" },
    ];
    const [searchText, setSearchText] = useState("");
    const [searchTextField, setSearchTextField] = useState({
        searchField: "",
        searchText: "",
    });
    const [searchInit, setSerarchInit] = useState(searchFieldList[0]);
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "itemName",
        sort: "asc",
    });
    const [spgInfo, setSpgInfo] = useState([]);
    let appPath = "zoneId=" + curTree.zone.zoneId;
    appPath = appPath + "&sort=" + sortData.sortField + "," + sortData.sort;
    // 페이징 적용된 주소
    appPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.size}`;
    if (curTree.subZone.subZoneId) {
        appPath = appPath + "&subZoneId=" + curTree.subZone.subZoneId;
    }
    // 전기실
    if (curTree.room.roomId) {
        appPath = appPath + "&roomId=" + curTree.room.roomId;
    }
    // spg
    if (curTree.spg.companySpgId > 0) {
        appPath = appPath + "&companySpgId=" + curTree.spg.companySpgId;
    }
    // spgSle
    if (recoilSpgData.spg.companySpgId > 0) {
        appPath = appPath + "&companySpgId=" + recoilSpgData.spg.companySpgId;
    }
    // 검색 필드
    if (searchTextField.searchText.length > 0) {
        appPath = appPath + `&searchKind=${searchTextField.searchField}&stringLike=${searchTextField.searchText}`;
    }
    // 기기목록 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/items?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + popReset + langIds,
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setChnanTree(curTree);
                setItemList(data.body);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: isMobile ? CONST.NUM_MLISTCNT : 5, listReload: false })); //5, 10; //5, 10
                //초기화
                if ((chnanTree && chnanTree !== curTree) || popReset) {
                    setSortData({
                        sortField: "itemName",
                        sort: "asc",
                    });
                    setSearchText("");
                    setSearchTextField({
                        searchField: searchFieldList[0].sfVal,
                        searchText: "",
                    });
                    handleCurPage(0);
                    setToday(null);
                    setCheckArr([]);
                    setCheckingItem([]);
                    setChecktypeItem([]);
                    setCheckSubtypeItem([]);
                    setCheckVersiontypeItem([]);
                    setSchduleAdd({
                        checkVersionId: -1,
                        isOutSource: false,
                        period: null,
                        inspector: userInfo.userName,
                        itemId: -1,
                    });
                    setMemo("");
                    setCheckSub("");
                    setErrorList([]);
                    setNewAdd(false);
                    setPopreset(false);
                }
                setRecoilIsLoadingBox(false);
            }
            else {
                // need error handle
                setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-s-add", type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-s-add");
                setRecoilIsLoadingBox(false);
            }
        }
    }, [data, curTree, popReset, langIds]);
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            goSearch(e);
        }
    }
    // 모바일 검색 버튼 이벤트
    function goSearch(e) {
        handleCurPage(0);
        setSearchTextField({
            searchText: searchText,
            searchField: searchInit.sfVal,
        });
    }
    // 정렬 버튼 액션
    function onClickSort(sort) {
        // list 수정
        handleCurPage(0);
        const sortVal = {
            field: sort,
            data: sortData,
            setData: setSortData,
        };
        CUTIL.onClickSort(sortVal);
    }
    // 체크박스 전체
    function CheckedAll(checked) {
        // spg 했을 시 활성화
        if (checked) {
            const checks = checkingItem.concat(itemList);
            var unique = checks.filter((item, pos) => checks.indexOf(item) === pos);
            const checksId = checkArr.concat(itemList.map((item) => item.id));
            var uniqueId = checksId.filter((item, pos) => checksId.indexOf(item) === pos);
            setCheckingItem(unique);
            setCheckArr(uniqueId);
        }
        else {
            let itemListId = itemList.map((item) => item.id);
            setCheckingItem(checkingItem.filter((item) => !itemListId.includes(item.id)));
            setCheckArr(checkArr.filter((item) => !itemListId.includes(item)));
        }
    }
    // checkbox
    function CheckedList(checked, list) {
        // spg 했을 시 중복 가능
        if (checked) {
            setCheckingItem([...checkingItem, list]);
            setCheckArr([...checkArr, list.id]);
        }
        else {
            setCheckingItem(checkingItem.filter((el) => el.id !== list.id));
            setCheckArr(checkArr.filter((el) => el !== list.id));
        }
    }
    // 진단 유형
    function CheckTypes(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (checkingItem.filter((type) => type.companySpgId).length > 0) {
                CUTIL.onClickSelect(e, CUTIL.selectOption);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktypes?companySpgId=${checkingItem[0].companySpgId}`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setChecktypeItem(data.body);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-s-add", type: CONST.TYPE_ERROR, divTag: data.body.map((err) => err.msg) }));
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-s-add");
                    }
                }
            }
            else {
                setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-s-add", type: CONST.TYPE_ERROR, divTag: t("라벨.점검기기를선택해주세요") }));
                CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-s-add");
            }
        });
    }
    //상세유형
    function CheckTypeSub(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setErrorList(errorList.filter((err) => err.field !== "checkType" && err.field !== "checkSub"));
            // setErrorList(errorList.filter((err) => (err.field !== "checkType")));
            let data = null;
            // 진단 유형 초기화
            if (!checkSub || checkSub == type.description) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/${type.checkTypeId}/checksubtypes`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckSubtypeItem(data.body);
                        setCheckSub(type.description);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-s-add", type: CONST.TYPE_ERROR, divTag: data.body.map((err) => err.msg) }));
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-s-add");
                    }
                }
            }
            else {
                setCheckSubtypeItem([]);
                setCheckVersiontypeItem([]);
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/${type.checkTypeId}/checksubtypes`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckSubtypeItem(data.body);
                        setCheckSub(type.description);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-s-add", type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-s-add");
                    }
                }
            }
        });
    }
    // 버젼
    function CheckTypeVersion(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setErrorList(errorList.filter((err) => err.field !== "checkType" && err.field !== "checkSub"));
            // setErrorList(errorList.filter((err) => (err.field !== "checkSub")));
            setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { checkVersionId: -1 }));
            let data = null;
            // 상세 유형 초기화
            if (!checkVersion || checkVersion == type.checkSubName) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckVersiontypeItem(data.body);
                        setCheckVersion(type.checkSubName);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-s-add", type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-s-add");
                    }
                }
            }
            else {
                setCheckVersiontypeItem([]);
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckVersiontypeItem(data.body);
                        setCheckVersion(type.checkSubName);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-s-add", type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-s-add");
                    }
                }
            }
        });
    }
    // 버젼 선택
    function CheckTypeVersionSel(type) {
        setErrorList(errorList.filter((err) => err.field !== "checkVersionId"));
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { checkVersionId: type.checkVersionId }));
    }
    // 점검 일자
    function onChangeToday(date) {
        setErrorList(errorList.filter((err) => err.field !== "dueDate"));
        setToday(date);
    }
    // 자동 점검주기
    function automaticCheckCycleClick(acc) {
        setErrorList(errorList.filter((err) => err.field !== "period"));
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { period: acc.value }));
    }
    // 점검
    function onChangInspector(e) {
        setErrorList(errorList.filter((err) => err.field !== "inspector"));
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { inspector: e.target.value }));
    }
    function SchdeulerAddpop(e) {
        if (checkingItem.length > 0) {
            handleOpenPop("pop-confirm", _jsx(ConfirmPop, { id: "pop-s-add", type: "today", clickfn: SchdeulerAdd }));
            CUTIL.jsopen_InnerPopup(CONST.POP_CONFIRM, "pop-s-add");
        }
        else {
            setRecoilSpgData({
                spg: { companySpgId: -1, spgId: -1, spgName: "" },
            });
            CUTIL.jsclose_Popup("pop-s-add");
        }
    }
    // 점검 예약 등록
    function SchdeulerAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            if (!checkSub ||
                !checkVersion ||
                schduleAdd.checkVersionId <= 0 ||
                schduleAdd.period == null ||
                !schduleAdd.inspector ||
                !today) {
                setErrorList([
                    !checkSub && { field: "checkType", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !checkVersion && { field: "checkSub", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    schduleAdd.checkVersionId <= 0 && { field: "checkVersionId", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !today && { field: "dueDate", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    schduleAdd.period == null && { field: "period", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !schduleAdd.inspector && { field: "inspector", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                ]);
                setRecoilIsLoadingBox(false);
            }
            else {
                // 다중
                let data = [];
                var success = [];
                var fail = [];
                for (let i = 0; i < checkingItem.length; i++) {
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "POST",
                        appPath: `/schedule`,
                        appQuery: {
                            dueDate: dayjs(today).format("YYYYMMDD").toString(),
                            itemId: checkingItem[i].id,
                            checkVersionId: schduleAdd.checkVersionId,
                            isOutSource: !schduleAdd.isOutSource,
                            period: schduleAdd.period,
                            inspector: schduleAdd.inspector,
                            memo: memo,
                        },
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            success.push(data.body);
                        }
                        else {
                            fail.push(data);
                        }
                    }
                }
                if (data) {
                    if (fail.length <= 0 && success.length > 0) {
                        setReload(true);
                        CUTIL.jsclose_Popup("pop-s-add");
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.예약이등록되었습니다") }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setPopreset(true);
                        setCheckItem([]);
                        setCheckArr([]);
                        setRecoilIsLoadingBox(false);
                    }
                    else if (success.length > 0 && fail.length > 0) {
                        setReload(true);
                        CUTIL.jsclose_Popup("pop-s-add");
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, pTag: {
                                p1: `예약 성공 ${success.length}건 입니다.`,
                                p2: `예약 실패 ${fail.length}건 입니다.`,
                            } }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setPopreset(true);
                        setCheckItem([]);
                        setCheckArr([]);
                        setRecoilIsLoadingBox(false);
                    }
                    else if (fail.length > 0 && success.length <= 0) {
                        setErrorList(data.errorList);
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function SelectClick(item) {
        if (searchInit !== item) {
            setSearchText("");
            setSerarchInit(item);
        }
    }
    //spg select
    function SpgSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/${curTree.company.companyId}/spgs`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSpgInfo(data.body);
                }
                else {
                    // alert(data.errorList.map((err) => (err.msg)));
                }
            }
        });
    }
    function onClickSpg(item) {
        setSortData({
            sortField: "itemName",
            sort: "asc",
        });
        setSearchText("");
        setSearchTextField({
            searchField: searchFieldList[0].sfVal,
            searchText: "",
        });
        handleCurPage(0);
        setToday(null);
        setCheckArr([]);
        setCheckingItem([]);
        setChecktypeItem([]);
        setCheckSubtypeItem([]);
        setCheckVersiontypeItem([]);
        if (item === "all") {
            setRecoilSpgData({
                spg: { companySpgId: -1, spgId: -1, spgName: "" },
            });
        }
        else {
            setRecoilSpgData({
                spg: { companySpgId: item.companySpgId, spgId: item.spgId, spgName: item.spgName },
            });
            setRecoilTreeData(Object.assign(Object.assign({}, recoilTreeData), { spg: { companySpgId: -1, spgId: -1, spgName: "", spgBoolean: false } }));
        }
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: curTree.company.companyName + " " + curTree.zone.zoneName + " " + curTree.subZone.subZoneName }), _jsx("li", { children: curTree.room.roomId ? curTree.room.roomName : t("라벨.전체") }), _jsx("li", { children: curTree.spg.spgBoolean ? curTree.spg.spgName : t("라벨.전체") })] })), _jsxs("div", Object.assign({ className: "flex-row" }, { children: [_jsxs("div", Object.assign({ className: `pop-left flex-1-4 ${pageInfo.totalElements == 0 ? "nodata" : ""}`, style: { display: newAdd ? "none" : "" } }, { children: [!isMobile && (_jsxs("div", Object.assign({ className: "tbl__top m-none" }, { children: [_jsx("div", Object.assign({ className: "left" }, { children: _jsxs("div", Object.assign({ className: "select w112", onClick: (e) => !curTree.spg.spgName && SpgSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: recoilSpgData.spg.companySpgId > 0
                                                                        ? recoilSpgData.spg.spgName
                                                                        : curTree.spg.companySpgId > 0
                                                                            ? curTree.spg.spgName
                                                                            : t("라벨.전체") })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSpg("all") }, { children: t("라벨.전체") })), spgInfo.map((info) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSpg(info) }, { children: info.spgName }), "itemPop_" + Math.random().toString())))] })] })) })), _jsxs("div", Object.assign({ className: "searcharea" }, { children: [_jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsxs("div", Object.assign({ className: "select m_search1", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: !popReset ? searchFieldList[0].sfDisp : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList.map((sf, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => SelectClick(sf), "data-value": sf.sfVal }, { children: sf.sfDisp }), "search_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "input__direct" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) }))] }))] }))), isMobile && (_jsx("div", Object.assign({ className: "tbl__top flex-column m-block" }, { children: _jsxs("div", Object.assign({ className: "searcharea brd-top-0 pt-0 m-mt-8" }, { children: [_jsxs("div", Object.assign({ className: "select w100p mb-16", onClick: (e) => !curTree.spg.spgName && SpgSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: recoilSpgData.spg.companySpgId > 0
                                                                        ? recoilSpgData.spg.spgName
                                                                        : curTree.spg.companySpgId > 0
                                                                            ? curTree.spg.spgName
                                                                            : t("라벨.전체") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: spgInfo.map((info) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSpg(info) }, { children: info.spgName }), curTree.room.roomId + ":" + info.spgId))) })] })), _jsxs("div", Object.assign({ className: "select m_search2 w100p ml-0", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: !popReset ? searchFieldList[0].sfDisp : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList
                                                                .filter((sf) => sf.sfVal !== "itemName")
                                                                .map((sf, idx) => (_jsx("li", Object.assign({ className: "option", "data-value": sf.sfVal }, { children: sf.sfDisp }), "search_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "flex-inline gap-8" }, { children: [_jsxs("div", Object.assign({ className: "input__direct wcal-48" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-blue", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) }))] }))] })) }))), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("라벨.조회된설비기기가없습니다") })), _jsxs("div", Object.assign({ className: "tbl-list tbl-select" }, { children: [" ", _jsxs("table", Object.assign({ summary: "\uC120\uD0DD, \uD615\uBA85, \uD310\uB12C\uBA85, \uC2DC\uB9AC\uC5BC\uBC88\uD638 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC124\uBE44\uC6A9 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC124\uBE44\uC6A9 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", Object.assign({ className: "m-none" }, { children: [_jsx("col", { style: { width: "50px" } }), _jsx("col", { style: { width: "28%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: {} })] })), _jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", Object.assign({ scope: "col", className: "txt-left w10p" }, { children: [_jsx("input", { type: "checkbox", id: "st_all", checked: checkingItem.length === 0 ? false : checkingItem.length === itemList.length ? true : false, disabled: !recoilSpgData.spg.spgName && !curTree.spg.spgName ? true : false, onChange: (e) => CheckedAll(e.target.checked) }), _jsx("label", Object.assign({ htmlFor: "st_all" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "itemName" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("itemName") }, { children: _jsx("span", { children: t("라벨.형명") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "panelName" && sortData.sort === "desc" ? "desc" : "asc"} m-none`, onClick: (e) => onClickSort("panelName") }, { children: _jsx("span", { children: t("라벨.판넬명") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "serialNo" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("serialNo") }, { children: _jsx("span", { children: t("라벨.시리얼번호") }) }))] }) }), _jsx("tbody", { children: itemList.length > 0 ? (itemList.map((list, idx) => (_jsxs("tr", { children: [_jsxs("td", Object.assign({ className: "w10p" }, { children: [_jsx("input", { type: "checkbox", id: "st_" + idx, checked: checkingItem.includes(list) ? true : false, disabled: !recoilSpgData.spg.spgName && !curTree.spg.spgName ? true : false, onChange: (e) => CheckedList(e.target.checked, list), style: { display: "none" } }), _jsx("label", Object.assign({ htmlFor: "st_" + idx }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("td", Object.assign({ className: `m-none ${list.itemName.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.itemName }, { children: _jsx("p", Object.assign({ className: "ellipsis " }, { children: list.itemName })) })), _jsx("td", Object.assign({ className: `${list.panelName.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.panelName }, { children: _jsx("p", Object.assign({ className: "ellipsis " }, { children: list.panelName })) })), _jsx("td", Object.assign({ className: `${list.serialNo.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.serialNo }, { children: _jsxs("p", Object.assign({ className: "ellipsis" }, { children: [list.serialNo, " "] })) }))] }, "item_pop" + idx.toString())))) : (_jsx("tr", { children: _jsx("td", Object.assign({ colSpan: isMobile ? 3 : 4 }, { children: _jsx("p", Object.assign({ className: "nodata__txt" }, { children: "\uC870\uD68C\uB41C \uB370\uC774\uD130\uAC00\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4." })) })) })) })] }))] })), _jsx(EhpPagination, { componentName: "TODAYPOP", pageInfo: pageInfo, handleCurPage: handleCurPage, checked: checkArr })] })), _jsxs("div", Object.assign({ className: "pop-right flex-1 m-none", id: "m-click-show" }, { children: [_jsx("h2", { children: t("라벨.진단설정") }), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${newAdd ? "disabled" : ""}` }, { children: t("라벨.점검유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [newAdd ? (_jsx("input", { type: "text", id: "inp2", disabled: true })) : (_jsxs("div", Object.assign({ className: `select diagnosis_type  ${errorList.filter((err) => err.field === "checkType").length > 0 ? " input-error" : ""} `, onClick: (e) => CheckTypes(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popReset ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkTypeItem &&
                                                                            checkTypeItem
                                                                                .filter((non) => non.checkTypeId != 4)
                                                                                .map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeSub(type) }, { children: type.description }), "type_" + idx.toString()))) })] }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkType").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${checkSubTypeItem.length <= 0 ? "disabled" : ""}` }, { children: t("라벨.상세유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [checkSubTypeItem.length <= 0 ? (_jsx("input", { type: "text", id: "inp2", disabled: true })) : (_jsxs("div", Object.assign({ className: `select diagnosis_subtype ${errorList.filter((err) => err.field === "checkSub").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popReset ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkSubTypeItem &&
                                                                            checkSubTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersion(type) }, { children: type.checkSubName }), "subtype_" + idx.toString()))) })] }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkSub").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${checkVersionTypeItem.length <= 0 ? "disabled" : ""}` }, { children: t("라벨.버전") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [checkVersionTypeItem.length <= 0 ? (_jsx("input", { type: "text", id: "inp2", disabled: true })) : (_jsxs("div", Object.assign({ className: `select diagnosis_ver ${errorList.filter((err) => err.field === "checkVersionId").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popReset ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkVersionTypeItem &&
                                                                            checkVersionTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersionSel(type) }, { children: type.versionNo }), "subVersion_" + idx.toString()))) })] }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkVersionId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${newAdd ? "disabled" : ""}` }, { children: t("라벨.점검예정일") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx(DatePicker, { className: `calendar ${errorList.filter((err) => err.field === "dueDate").length > 0 ? " input-error" : ""}`, locale: langs === CONST.STR_LANG_ENG ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: today, onChange: (date) => onChangeToday(date), 
                                                                // onFocus={(e) => e.target.readOnly = true} // 모바일 키보드 제거
                                                                withPortal: isMobile ? true : false, 
                                                                // readOnly={(dateSel != 0) ? true : false}  // 직접 입력 이외 입력 제한
                                                                disabled: newAdd ? true : false, minDate: new Date(), placeholderText: t("라벨.점검예정일선택") }), _jsx("p", Object.assign({ className: "input-errortxt", style: {
                                                                    display: errorList.filter((err) => err.field === "dueDate").length > 0 ? "block" : "none",
                                                                } }, { children: errorList.filter((err) => err.field === "dueDate").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${newAdd ? "disabled" : ""}` }, { children: t("라벨.자동점검주기") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [newAdd ? (_jsx("input", { type: "text", id: "inp2", disabled: true })) : (_jsxs("div", Object.assign({ className: `select diagnosis_auto ${errorList.filter((err) => err.field === "period").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popReset ? t("라벨.점검주기를선택해주세요") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: automaticCheckCycle.map((acc, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => automaticCheckCycleClick(acc) }, { children: acc.cycleNo }), "ACC_" + idx.toString()))) })] }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "period").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${newAdd ? "disabled" : ""}` }, { children: t("라벨.점검자") })), _jsxs("div", Object.assign({ className: `input__area ` }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "inspector").length > 0 ? " input-error" : ""}`, type: "text", id: "inp3", placeholder: newAdd ? "" : t("라벨.텍스트입력"), value: newAdd ? "" : schduleAdd.inspector, onChange: (e) => onChangInspector(e), disabled: newAdd ? true : false }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "inspector").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${newAdd ? "disabled" : ""}` }, { children: t("라벨.점검메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: newAdd ? "" : t("라벨.텍스트입력"), value: newAdd ? "" : memo, onChange: (e) => setMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setMemo), disabled: newAdd ? true : false }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [newAdd ? "0" : memo.length, " / 400"] }))] }))] })] }))] }))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [!isMobile && (_jsx("button", Object.assign({ type: "button", className: "js-open m-none", "data-pop": "pop-confirm", onClick: (e) => SchdeulerAddpop(e) }, { children: _jsx("span", { children: checkingItem.length > 0 ? t("라벨.저장") : t("라벨.확인") }) }))), isMobile && (_jsx("button", Object.assign({ type: "button", className: "m-click-show", "data-pop": "m-click-show", onClick: (e) => CUTIL.mClickShow(e) }, { children: _jsx("span", { children: t("라벨.다음") }) }))), isMobile && (_jsx("button", Object.assign({ type: "button", className: "bg-white go-prev m-none" }, { children: _jsx("span", { children: t("라벨.뒤로") }) }))), isMobile && (_jsxs("button", Object.assign({ type: "button", className: "go-save m-none", onClick: (e) => SchdeulerAddpop(e) }, { children: [" ", _jsx("span", { children: checkingItem.length > 0 ? t("라벨.저장") : t("라벨.확인") })] })))] }))] }));
}
function ConfirmPop(props) {
    const t = useTrans();
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: "\uC124\uBE44 \uBC0F \uC9C4\uB2E8 \uC815\uBCF4\uB97C \uB4F1\uB85D\uD574 \uC8FC\uC138\uC694." }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close" }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button" }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
